import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { mapsEmbed } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { PageHeader, Panel } from "@/components/crm/Badges";
import { DemoWipePanel } from "@/components/crm/admin/DemoWipePanel";
import { BrandPanel } from "@/components/crm/admin/BrandPanel";
import { SiteImagesPanel } from "@/components/crm/admin/SiteImagesPanel";

const FIELDS = [
  ["name", "Nombre del centro"], ["tagline", "Frase corta"], ["address", "Dirección"], ["phone", "Teléfono"],
  ["whatsapp", "WhatsApp (con código de país, solo dígitos)"], ["email", "Correo"], ["map_query", "Búsqueda para el mapa"],
  ["phone_country_code", "Código de país por defecto (teléfonos)"],
  ["facebook", "Facebook (URL)"], ["instagram", "Instagram (URL)"], ["tiktok", "TikTok (URL)"], ["linkedin", "LinkedIn (URL)"],
];

export default function CenterPage() {
  const [v, setV] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/admin/settings/center").then((r) => setV({ ...r.data, hoursText: (r.data.hours || []).join("\n") })); }, []);
  if (!v) return <Loader2 className="h-6 w-6 animate-spin text-[#1E6FD9]" />;

  const save = async () => {
    setSaving(true);
    const { hoursText, ...rest } = v;
    try {
      await api.put("/admin/settings/center", { ...rest, hours: hoursText.split("\n").map((h) => h.trim()).filter(Boolean) });
      toast.success("Información del centro actualizada");
    } catch (e) { toast.error(errorMessage(e)); } finally { setSaving(false); }
  };

  return (
    <div data-testid="center-page">
      <PageHeader title="Centro y contacto" subtitle="Datos visibles en el sitio público">
        <Button onClick={save} disabled={saving} className="rounded-xl bg-[#1E6FD9]" data-testid="center-save-button">Guardar cambios</Button>
      </PageHeader>
      <div className="grid gap-6 xl:grid-cols-3">
        <Panel className="xl:col-span-2">
          <div className="grid gap-4 sm:grid-cols-2">
            {FIELDS.map(([k, l]) => (
              <div key={k}>
                <Label className="text-xs font-semibold text-slate-600">{l}</Label>
                <Input value={v[k] || ""} onChange={(e) => setV((s) => ({ ...s, [k]: e.target.value }))} className="mt-1.5 h-10 rounded-xl" data-testid={`center-input-${k}`} />
              </div>
            ))}
            <div className="sm:col-span-2">
              <Label className="text-xs font-semibold text-slate-600">Horarios (uno por línea)</Label>
              <Textarea rows={4} value={v.hoursText} onChange={(e) => setV((s) => ({ ...s, hoursText: e.target.value }))} className="mt-1.5 rounded-xl" data-testid="center-input-hours" />
            </div>
          </div>
        </Panel>
        <Panel title="Vista previa del mapa">
          <div className="aspect-square overflow-hidden rounded-xl border border-slate-200">
            <iframe title="Mapa" src={mapsEmbed(v.map_query || v.address)} className="h-full w-full border-0" loading="lazy" />
          </div>
        </Panel>
      </div>
      <BrandPanel />
      <SiteImagesPanel />
      <DemoWipePanel />
    </div>
  );
}
